import type talentZh from '../zh/talent';

const talent: typeof talentZh = {
  title: 'Creator Square',
  search_placeholder: 'Search creators / names',
  market: 'Market',
  category: 'Category',
  category_placeholder: 'Select a category',
  category_selected: 'Selected',
  category_search: 'Search categories',
  all: 'All',
  market_vn: 'Vietnam',
  market_th: 'Thailand',
  market_id: 'Indonesia',
  market_my: 'Malaysia',
  market_ph: 'Philippines',
  market_sg: 'Singapore',
  cat_beauty: 'Beauty',
  cat_home: 'Home',
  cat_fashion: 'Fashion',
  cat_digital: 'Digital',
  cat_lifestyle: 'Lifestyle',
  add_to_mine: 'Add to my creators',
  select_required: 'Select creators first',
  already_collected: 'Selected creators are already saved',
  batch_outreach: 'Bulk outreach',
  batch_invite: 'Batch invite',
  my_talents: 'My creators',
  col_talent: 'Creator',
  followers: 'Followers',
  gmv30: '30-day GMV',
  email: 'Email',
  status: 'Status',
  status_pending: 'Pending outreach',
  status_replied: 'Replied',
  status_cooperated: 'Collaborating',
  status_blacklist: 'Blacklist',
  load_failed: 'Failed to load creators',
  category_load_failed: 'Could not load categories',
  col_actions: 'Actions',
  has_email: 'Has email',
  favorited: 'Saved',
  favorite: 'Save',
  collect_success: 'Saved',
  collect_failed: 'Could not save this creator',
  missing_open_id: 'Missing influencer ID',
  outreach: 'Outreach',
  target_invite: 'Targeted invite',
  blacklist: 'Blacklist',
  detail_title: 'Creator details',
  detail_load_failed: 'Failed to load creator details',
  pps_score: 'PPS score',
  live_gmv: 'Live GMV',
  video_gmv: 'Video GMV',
  gmv_range: 'GMV range',
  units_sold_range: 'Units sold range',
  avg_live_uv: 'Avg. live UV',
  avg_video_views: 'Avg. video views',
  creator_level: 'Creator level',
  audience: 'Audience',
  age_range: 'Top age',
  major_gender: 'Top gender',
  gender_male: 'Male',
  gender_female: 'Female',
  demographics: 'Demographics',
  official_recommend: 'Official pick',
  fast_growing: 'Fast growing',
  collaborated: 'Collaborated',
  invited_90d: 'Invited in 90 days',
  creator_blocked: 'Blocked',
  flat_fee: 'Flat fee',
  rising_star: 'Rising star',
  privacy_creator: 'Private creator',
  original_creator: 'Original creator',
  mcn: 'MCN',
  created_at: 'Created',
  updated_at: 'Updated',
  match_score: 'Match score',
  start_outreach: 'Start outreach',
  view_emails: 'View email thread',
  block: 'Block',
  gmv7: '7-day GMV',
  coop_products: 'Collab products',
  content_count: 'Content count',
  email_yes: 'Yes',
  email_no: 'No',
  why_fit: 'Why this creator fits',
  why_fit_fallback:
    '{{name}} matches the current store category, with followers concentrated in Southeast Asia. Start with email outreach and a targeted invite.',
  timeline: 'Collaboration timeline',
  no_record: 'No records yet',
  timeline_empty_desc: 'The interaction timeline will appear after you start outreach.',
  products_title: 'Promoted products',
  products_empty: 'No sales data',
  col_product: 'Product',
  col_gmv: 'GMV',
  col_output: 'Output'
};

export default talent;
